/**
 * La base locale, et son schéma.
 *
 * Le client détient une copie complète et fait autorité pendant la session
 * (ADR-001) : rien ici n'attend le réseau, et l'application fonctionne dans une
 * cave sans couverture. Le serveur viendra plus tard comme point de
 * convergence, pas comme source de vérité.
 *
 * Deux tables, et elles ne se comportent pas pareil :
 *
 * - `personnages` porte un **état**, qu'on relit et réécrit. Il a une révision,
 *   et deux versions concurrentes seront un conflit à arbitrer.
 * - `jets` porte des **faits**, qu'on ajoute et qu'on ne reprend jamais. Deux
 *   appareils qui journalisent chacun de leur côté se fusionnent sans rien
 *   demander à personne.
 */

import Dexie from 'dexie'

export const base = new Dexie('lotc')

// Les index secondaires servent le tri et le filtre ; le reste du contenu n'est
// pas interrogé, seulement relu en entier.
base.version(1).stores({ personnages: 'id, nom, modifie_le' })
base.version(2).stores({ jets: 'id, personnage_id, horodatage' })
